"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdvDate_1 = require("../lib/AdvDate");
var FROM_DATES = [
    new AdvDate_1.AdvDate("01/01/1900"),
    new AdvDate_1.AdvDate("01/07/1960"),
    new AdvDate_1.AdvDate("01/07/1961"),
    new AdvDate_1.AdvDate("01/07/1962"),
    new AdvDate_1.AdvDate("01/07/1963"),
    new AdvDate_1.AdvDate("01/07/1964")
];
var PRESERVATION_AGES = [55, 56, 57, 58, 59, 60];
var PreservationTable = (function () {
    function PreservationTable(fromDates, preservationAges) {
        this._fromDates = fromDates;
        this._preservationAges = preservationAges;
    }
    PreservationTable.createDefault = function () {
        return new PreservationTable(FROM_DATES, PRESERVATION_AGES);
    };
    PreservationTable.prototype.preservationAge = function (dateOfBirth) {
        var i = 0;
        for (i = this._fromDates.length - 1; i >= 0; i--) {
            if (dateOfBirth.getTime() >= this._fromDates[i].getTime()) {
                return this._preservationAges[i];
            }
        }
        return NaN;
    };
    return PreservationTable;
}());
exports.PreservationTable = PreservationTable;
//# sourceMappingURL=PreservationTable.js.map